<template>
  <div class="col-sm-12">
    <br />
    <br />
    <h3>Downloading a User File</h3>
    <table>
      <tbody>
        <tr>
          <td>
            <p class="NOTE">
              If you have created a file using the
              <a class="text" href="/admin-points-faq/create">Build new user file</a> tool, a link to your file will appear here. Simply click on the
              link. You will probably receive a warning dialog box like this:
            </p>
            <div></div>
            <p class="note">
              Choose "save" and find a location on your local hard drive that you can remember ("my documents" works well). Once the file is
              downloaded you can open it and use it.
            </p>
            <br />
            <br /><br />
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <br />
  </div>
</template>
<script>
export default {
  name: 'PreviousFiles',
};
</script>
<style scoped>
table {
  border: 0px solid transparent;
  font-size: 14px;
  width: inherit;
}
fieldset {
  padding: 0.35em 0.625em 0.75em;
  margin: 0 5px;
  border: 1px solid silver;
  border-radius: 8px;
}
legend {
  width: auto;
  padding: 10px;
  font-size: 15px;
  color: #333;
  border: 0;
  border-bottom: none;
}
</style>
